module.exports = __webpack_public_path__ + "img/cbt_healed--active.7475a7bc.svg";